@if (isVisible) {
  <div id="smart-chatbot-container" [style.--chatbot-primary-hsl]="primaryColor"
    [style.--chatbot-secondary-hsl]="secondaryColor">
    <div id="smart-chatbot-window" [class.open]="isOpen" [style.opacity]="isOpen ? '1' : '0'"
      [style.pointer-events]="isOpen ? 'auto' : 'none'">
      <div class="smart-chatbot-header">
        <div class="smart-chatbot-header-brand">
          @if (showLogo) {
            <img [src]="logoUrl" alt="Logo" class="smart-chatbot-logo">
          }
          <span class="smart-chatbot-header-title">{{ chatbotName }}</span>
        </div>
        <button id="smart-chatbot-close" type="button" (click)="close($event)"
          style="background:transparent;border:none;color:white;cursor:pointer;font-size:24px;line-height:1;"
        aria-label="Fermer">&times;</button>
      </div>
      <div id="smart-chatbot-messages" #messagesEl>
        @for (msg of messages; track msg) {
          <div class="smart-chatbot-message" [class.bot]="msg.role === 'bot'"
            [class.user]="msg.role === 'user'">
            @if (msg.role === 'bot') {
              <div [innerHTML]="msg.html"></div>
            } @else {
              {{ msg.text }}
            }
          </div>
        }
      </div>
      <div class="smart-chatbot-input-container">
        <input #inputEl type="text" id="smart-chatbot-input" [value]="inputValue" [disabled]="inputDisabled"
          (input)="onInput(inputEl.value)" (keypress)="onEnter($event)" placeholder="Saisir votre message...">
          <button id="smart-chatbot-send" type="button" (click)="sendMessage()" [disabled]="inputDisabled">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"></path>
            </svg>
          </button>
        </div>
      </div>
      <div id="smart-chatbot-button" (click)="toggleOpen()" role="button" tabindex="0">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path
            d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z">
          </path>
        </svg>
      </div>
    </div>
  }